import { logout } from "../modules/auth/actionCreators";
import UserService from "../../utils/keycloak/UserService";

// typically client will be an instance of ApiClient
export default function clientMiddleware(client) {
  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      if (typeof action === "function") {
        return action(dispatch, getState);
      }

      const { promise, types, ...rest } = action; // eslint-disable-line no-redeclare
      if (!promise) {
        return next(action);
      }

      // if the action that was dispatched has a 'promise' key
      // dispatch a REQUEST action (as extracted from the 'types' key)
      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });

      // Proactively ensure token is valid (> 30s remaining) before making API calls
      return UserService.updateToken(30).then(
        () => {
          const actionPromise = promise(client);
          actionPromise.then(
            (result) => {
              next({ ...rest, result, type: SUCCESS });
            },
            (error) => {
              // if authentication fails, logout and navigate to the login screen
              if (error && (error.status === 401 || error.statusCode === 401)) {
                next(logout());
              }
              next({ ...rest, error, type: FAILURE });
            }
          );
          return actionPromise;
        },
        (error) => {
          if (error && (error.status === 401 || error.statusCode === 401)) {
            next(logout());
          }
        }
      );
    };
}

